import {getFeatureSettings} from './getFeatureSettings'
import {fetchFeatures} from './fetchFeatures'

export const featureSettings = {
  getFeatureSettings,
  fetchFeatures,
}
